/**
 * AdminPage
 * Protected route wrapper for admin dashboard
 * Feature: User Management (002-user-management) - Phase 3
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import AdminDashboard from '../components/AdminDashboard';

const AdminPage = () => {
  const { isAuthenticated, user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        // Not authenticated, redirect to login
        navigate('/login', { state: { from: '/admin' } });
      } else if (user && user.role !== 'admin' && user.role !== 'super_admin') {
        // Other roles go to public dashboard
        navigate('/');
      }
    }
  }, [isAuthenticated, user, loading, navigate]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#999'
      }}>
        Loading...
      </div>
    );
  }

  // Only render if authenticated and is admin or super_admin
  if (!isAuthenticated || !user || (user.role !== 'admin' && user.role !== 'super_admin')) {
    return null;
  }

  return <AdminDashboard />;
};

export default AdminPage;
